const NEGATION_REGEX =
  /\b(no\s+evidence\s+of|no\s+signs?\s+of|no\s+history\s+of|negative\s+for|free\s+of|without|denies|denied|not|no)\b/i;
const NEGATION_RESET_REGEX = /\b(but|however|although|yet|except|reports?|has|positive\s+for|evidence\s+of)\b/i;

export interface TextMatchesUnnegatedOptions {
  extendNegationThroughCommas?: boolean;
}

function isNegated(text: string, matchIndex: number, options: TextMatchesUnnegatedOptions): boolean {
  const clauseStart = Math.max(
    text.lastIndexOf(".", matchIndex - 1) + 1,
    text.lastIndexOf(";", matchIndex - 1) + 1,
    ...(options.extendNegationThroughCommas ? [] : [text.lastIndexOf(",", matchIndex - 1) + 1]),
    text.lastIndexOf("\n", matchIndex - 1) + 1,
    text.lastIndexOf("\r", matchIndex - 1) + 1,
    0
  );
  const context = text.slice(clauseStart, matchIndex);
  const negationMatches = Array.from(context.matchAll(new RegExp(NEGATION_REGEX.source, "gi")));
  const negationMatch = negationMatches.at(-1);

  if (!negationMatch || negationMatch.index === undefined) return false;

  const textAfterNegation = context.slice(negationMatch.index + negationMatch[0].length);

  return !NEGATION_RESET_REGEX.test(textAfterNegation);
}

export function buildKeywordRegex(keywords: string[]): RegExp {
  const escaped = keywords.map((keyword) => keyword.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));

  return new RegExp(`\\b(?:${escaped.join("|")})\\b`, "gi");
}

export function textMatchesUnnegated(
  text: string | null | undefined,
  keywordRegex: RegExp,
  options: TextMatchesUnnegatedOptions = {}
): boolean {
  if (!text) return false;

  const globalRegex = keywordRegex.global ? keywordRegex : new RegExp(keywordRegex.source, `${keywordRegex.flags}g`);

  for (const match of text.matchAll(globalRegex)) {
    if (match.index === undefined) continue;
    if (!isNegated(text, match.index, options)) return true;
  }

  return false;
}
